<template>
  <div>
    <BreadCrumb :data="breadcrumb" :title="'其他列表管理'" />
    <BannerManage :title="'展馆轮播'" :position="'exhibitionIndex-banner'" />
    <div class="search-tags">
      <p
        class="search-tag"
        :class="item == selectedTag ? 'active' : ''"
        v-for="item in titles"
        :key="item.id"
        @click="changeTag(item)"
      >
        {{ item }}
      </p>
    </div>
    <DesignerTable  v-if='selectedTag=="Designer"'/>
    <OrganizationTable  v-if='selectedTag=="Organization"'/>
    <BaseTable  v-if='selectedTag=="Base"'/>
  </div>
</template>

<script>
import BannerManage from "../../componentSet/BannerCarousel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import BaseTable from "./component/BaseTable.vue";
import DesignerTable from "./component/DesignerTable.vue";
import OrganizationTable from "./component/OrganizationTable.vue";
export default {
  data() {
    return {
      selectedTag: "Designer",
      titles: ["Designer","Organization","Base"],
    };
  },
  components: {
    BaseTable,
    DesignerTable,
    OrganizationTable,
    BreadCrumb,
    BannerManage
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "其他列表", link: "/admin/otherList" },
      ];
    },
  },
  methods:{
      changeTag(item){
      this.selectedTag = item
    },
  }
};
</script>

<style lang="scss" scoped>
.search-tags {
  display: flex;
  margin-top: 20px;
  border-bottom: 2px solid $indexHotLine;
  margin-bottom: 33px;
  .search-tag {
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    margin-right: 50px;
    cursor: pointer;
  }
  .active {
    color: $timeBtn;
    border-bottom: 6px solid $timeBtn;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/admin/exhibition/OtherList.vue